var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{staticStyle:{"color":"#faad14"},attrs:{"icon":"save","size":"small","type":"link"},on:{"click":e => _vm.$emit('click', e)}},[_vm._v(" 保存 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }